// oxlint-disable node/no-process-env
import { createEnv as createEnvOg } from '@t3-oss/env-nextjs'
import { mapEntries } from 'radashi'

/**
 * Wraps {@link @t3-oss/env-nextjs#createEnv} to resolve environment variable references. We try to do this at build
 * time, but middleware does not seem to correctly respect this.
 *
 * Note: this won't work if you have a NEXT_PUBLIC_ prefixed environment variable that references a non-NEXT_PUBLIC_
 * prefixed environment variable. However, this is only Next SSR/client and our build-time support seems to be
 * sufficient for that.
 */
export const createEnv: typeof createEnvOg = (args) =>
  createEnvOg(
    // oxlint-disable-next-line prefer-object-spread
    Object.assign({}, args, {
      experimental__runtimeEnv: {
        ...baseResolvedEnv,
        ...args.experimental__runtimeEnv,
      },
    })
  )

function resolveEnv(key: string | number): string | undefined {
  const value = process.env[key]
  if (value?.startsWith('$')) {
    return resolveEnv(value.slice(1))
  }
  return value
}

const baseResolvedEnv = mapEntries(process.env, (key) => [key, resolveEnv(key)])
